module.exports = new __parcel__URL__("approved-file.3645ad0e.png").toString();